// The STORE OS mark and copyright, bottom left: in the side menu once someone is signed in, and
// in the corner of the sign-in screens.
export const COPYRIGHT_YEAR = new Date().getFullYear();

export function NavLegal() {
  return (
    <div className="nav-legal" title={`STORE OS · © ${COPYRIGHT_YEAR} STORE OS. All rights reserved.`}>
      <img src="/assets/store-os-icon-128.png" alt="" width={22} height={22} />
      <span className="nl-name">STORE OS</span>
      <span>© {COPYRIGHT_YEAR}</span>
      <span>All rights reserved.</span>
    </div>
  );
}

/**
 * The STORE OS mark at the bottom left of every receipt, ticket and full-page invoice. The picture
 * and the text sit side by side as inline blocks (a picture that is a block or a flex item can be
 * pushed onto a new page by Chrome's print layout).
 */
export function ReceiptMark() {
  return (
    <div className="sos-mark">
      <img src="/assets/store-os-icon-128.png" alt="" width={20} height={20} />
      <span className="sos-t"><strong>STORE OS</strong><br />© {COPYRIGHT_YEAR} STORE OS. All rights reserved.</span>
    </div>
  );
}

export function LegalFooter() {
  return (
    <footer className="legal-foot">
      <img src="/assets/store-os-icon-128.png" alt="" width={20} height={20} />
      <span><strong>STORE OS</strong> · © {COPYRIGHT_YEAR} STORE OS. All rights reserved.</span>
    </footer>
  );
}
